import { create } from 'zustand'

type AuthState = {
	role: string | null
	email: string | null
	keepMeLoggedIn: boolean
	setRole: (role: string | null) => void
	setEmail: (email: string | null) => void
	setKeepMeLoggedIn: (keepMeLoggedIn: boolean) => void
	setAuthValues: (values: { role?: string | null; email?: string | null; keepMeLoggedIn?: boolean }) => void
}

export const useAuthStore = create<AuthState>(set => ({
	role: null,
	email: null,
	keepMeLoggedIn: false,

	setRole: role => set({ role }),
	setEmail: email => set({ email }),
	setKeepMeLoggedIn: keepMeLoggedIn => set({ keepMeLoggedIn }),

	setAuthValues: ({ role, email, keepMeLoggedIn }) =>
		set(state => ({
			role: role !== undefined ? role : state.role,
			email: email !== undefined ? email : state.email,
			keepMeLoggedIn: keepMeLoggedIn !== undefined ? keepMeLoggedIn : state.keepMeLoggedIn
		}))
}))
